/**
 * Aponta o JS de carrinho do Dawn para a section base-cart-drawer.
 *
 * As classes CartDrawer e CartDrawerItems do Dawn pedem à Section Rendering
 * API a section 'cart-drawer'. Como o drawer do tema base é outra section,
 * elas buscariam o markup errado — sem blocos, sem upsell.
 *
 * Trocamos só o nome da section nos dois getSectionsToRender. As tags
 * <cart-drawer> e <cart-drawer-items> continuam as do Dawn, então
 * product-form.js (que faz document.querySelector('cart-drawer')),
 * quantity-popover.js e o CSS seguem funcionando sem fork.
 */
(() => {
  const SECTION_ID = 'base-cart-drawer';

  const patch = () => {
    const CartDrawer = customElements.get('cart-drawer');
    const CartDrawerItems = customElements.get('cart-drawer-items');
    if (!CartDrawer || !CartDrawerItems) return false;

    // Fluxo de adicionar ao carrinho: substitui o conteúdo de #CartDrawer.
    CartDrawer.prototype.getSectionsToRender = function () {
      return [{ id: SECTION_ID, selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
    };

    // Fluxo de mudar quantidade / remover: substitui o conteúdo de .drawer__inner.
    CartDrawerItems.prototype.getSectionsToRender = function () {
      return [
        { id: 'CartDrawer', section: SECTION_ID, selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    };

    /**
     * O terceiro ponto de entrada, e o mais escondido: o cart.js do Dawn ouve o
     * evento cartUpdate (publicado pelo product-form ao adicionar) e, no
     * onCartUpdate, busca `?section_id=cart-drawer` — o drawer ORIGINAL, que não
     * tem bloco nenhum — e faz replaceWith em <cart-drawer-items>.
     *
     * Resultado: o drawer abre certo e, um segundo depois, quando essa segunda
     * requisição volta, os blocos (banner de frete, upsell, custom liquid) somem.
     * Trocamos a section buscada e o seletor do rodapé, que aqui é .drawer__footer.
     */
    CartDrawerItems.prototype.onCartUpdate = function () {
      return fetch(`${routes.cart_url}?section_id=${SECTION_ID}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          ['cart-drawer-items', '.drawer__footer'].forEach((selector) => {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    };

    return true;
  };

  // cart-drawer.js é carregado com defer, então pode não ter registrado os
  // elementos ainda. whenDefined resolve sem polling.
  if (!patch()) {
    Promise.all([customElements.whenDefined('cart-drawer'), customElements.whenDefined('cart-drawer-items')]).then(
      patch
    );
  }
})();
